export const OVERRIDABLE_FIELDS = {
  products: [
    { field: 'price', type: ['number', 'decimal'], label: 'Prix' },
    { field: 'price_discount', type: ['number', 'decimal'], label: 'Prix remisé' },
  ],
};

export default OVERRIDABLE_FIELDS;
